module.exports = __webpack_public_path__ + "static/media/example.b1d1a204.gif";